import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { SharedModule } from '../shared/shared.module';
import { CustomerCancelledCredentialsComponent } from './components/customer-cancelled-credentials/customer-cancelled-credentials.component';
import { BaseDriverPageComponent } from './components/shared/base-driver-page.component';
import { CredentialBadgeComponent } from './credential/badge.component';
import { DriverExaminationLanguageSelectorModalComponent } from './credential/issuance/requirement/driver-examination-language-selector-modal.component';
import { DriverCoreModule } from './driver-core.module';
import { ExpirationDatePipe } from './pipes/expiration-date.pipe';
import { PrivilegeBadgeComponent } from './privilege/badge.component';

@NgModule({
    declarations: [
        CredentialBadgeComponent,
        PrivilegeBadgeComponent,
        CustomerCancelledCredentialsComponent,
        ExpirationDatePipe,
        DriverExaminationLanguageSelectorModalComponent,
        BaseDriverPageComponent
    ],
    providers: [
    ],
    imports: [
        RouterModule,
        SharedModule,
        DriverCoreModule,
        TableModule,
        DropdownModule
    ],
    exports: [
        CredentialBadgeComponent,
        PrivilegeBadgeComponent,
        CustomerCancelledCredentialsComponent,
        ExpirationDatePipe,
        DriverExaminationLanguageSelectorModalComponent,
        BaseDriverPageComponent
    ]
})
export class DriverSharedModule {
}
